import { Component, ViewChild, Input, ElementRef, Output, EventEmitter } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { Users, User, Route, TourPlan, ViewTabs } from './model/model.class';
import { Labels } from './model/language.model.class';
import { SharedService } from "./shared.service";
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'bar-component',
  templateUrl: './bar.component.html',
  styleUrls: ['./bar.component.css']
})
export class BarComponent {

  @Input() labels: Labels;
  @Input() mapNumber: number = 1;
  @ViewChild('userSearch') userSearchElement: ElementRef;
  tourPlan: TourPlan;
  filterDate: Date;
  dailyMeetingMarkers = [];
  recurringMarkers = [];
  users: User[] = [];
  private subscription: Subscription;
  actualTab: ViewTabs = ViewTabs.Map;
  inputDate: boolean;
  getUserInProgress: boolean;
  public userInput: string = '';
  showNoMatch: boolean = false;

  @Output() onVendorButtonClicked = new EventEmitter<number>();
  @Output() onTestCenterMapPointButtonClicked = new EventEmitter<number>();
  @Output() userTyping = new EventEmitter<void>();

  constructor(private _sanitizer: DomSanitizer, private sharedService: SharedService) {
    this.inputDate = false;
    this.getUserInProgress = false;
    this.filterDate = this.sharedService.filterDate;  
    this.sharedService.tourPlanEvent.subscribe(data => {
      if (this.mapNumber == data.mapNumber) {
        this.tourPlan = data.tourPlan;
      }
      this.sharedService.displayLoader(false);
    });

    this.sharedService.markersEvent.subscribe(data => {
      if (this.mapNumber == data.mapNumber) {
        this.dailyMeetingMarkers = data.markers.dailyMeetingMarkers;
        this.recurringMarkers = data.markers.recurringMarkers;
        this.sharedService.displayLoader(false);
        if (this.mapNumber == 2) {
          this.filterDate = this.sharedService.date2;
        }
      }
    });

    this.sharedService.tabEvent.subscribe(tabView => {
      this.actualTab = tabView;
      this.inputDate = tabView != ViewTabs.Map;
    });

    this.sharedService.user$.subscribe(user => {
      if (user) {
        this.userInput = user.Username;
      }
    });
  }

  ngOnInit() {
    this.userInput = sessionStorage.getItem('userInput') || '';
    document.addEventListener('click', () => this.showNoMatch = false);
  }


  public getUsers(keyword: string) {
    this.userTyping.emit();
    if (this.sharedService.isVendorPopupVisible) {
      this.sharedService.isVendorPopupVisible = false;
    }
    if (keyword.length < 3) {
      this.users = [];
      this.showNoMatch = false;
      return;
    }

    this.users = [];
    this.getUserInProgress = true;
    this.showNoMatch = false;

    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    this.getUsersAPI(keyword);
  }

  private getUsersAPI(keyword: string) {
    this.subscription = this.sharedService.getUsers(keyword).subscribe(
      res => {
        this.users = res || [];
        this.getUserInProgress = false;
        // Mostra "No match found" solo se non ci sono utenti
        this.showNoMatch = this.users.length === 0;
      },
      err => {
        this.users = [];
        this.getUserInProgress = false;
        this.showNoMatch = true; // opzionale
      }
    );
  }

  selectUser(u: User) {
    this.userInput = u.Username;
    sessionStorage.setItem('userInput', this.userInput);
    this.users = [];
    this.showNoMatch = false; 
    this.setGeo(u);
  }

  private userSearchEvents() {
    setTimeout(() => {
      this.userSearchElement.nativeElement.blur();
      this.userSearchElement.nativeElement.focus();
    }, 0);
  }

  
  private setGeo(user) {
    this.sharedService.setUser(user);

    if (this.actualTab == ViewTabs.Map) this.sharedService.getTourPlan(user.Id, this.filterDate, true);
    if (this.actualTab == ViewTabs.VisitDistribution) {
      this.sharedService.getVisitDistribution(user.Id, this.filterDate);
    }
    if (this.actualTab == ViewTabs.WorkLoad) {
      this.sharedService.getWorkLoad(user.Id, this.filterDate);
    }
    if (this.actualTab == ViewTabs.Kpi) {
      this.sharedService.getKKPI(user.Id, this.filterDate);
    }
  }

  private setDate(date) {
    this.filterDate = new Date(date);
    if (this.sharedService.user != undefined)
      this.sharedService.getTourPlan(this.sharedService.user.Id, this.filterDate, true);
  }

  
  private setDailyMeeting() {
    this.sharedService.setPlanned(true);
  }

  private openMarker(marker) {
    const customerId = (marker as any).customerid;
    const lat = marker.getPosition().lat();
    const lng = marker.getPosition().lng();

    this.dailyMeetingMarkers.forEach(m => {
      const mCustomerId = (m as any).customerid;
      const mLat = m.getPosition().lat();
      const mLng = m.getPosition().lng();

      if (
        mCustomerId === customerId ||
        (mLat === lat && mLng === lng)
      ) {
        m.setVisible(false); 
      }
    });

    marker.setVisible(true);
    // simulate click on marker
    new google.maps.event.trigger(marker, 'click');
  }

  public getCustomerName(name, i) {
    return String.fromCharCode(97 + i).toUpperCase() + ") " + name;
  }

  public Today() {
    return new Date;
  }

  autocompleListFormatter = (data: any) => {
    const html = `
    <div class="autocomplete-row mdl-grid mdl-grid--no-spacing">
      <div class="icon-cell mdl-cell mdl-cell--2-col">
        <i class="material-icons">face</i>
      </div>

      <div class="username-cell mdl-cell mdl-cell--10-col">
        <span class="span-bar-component">${data.Username}</span>
      </div>

      <div class="account-cell mdl-cell mdl-cell--6-col">
        <span>${this.labels.AccountType[data.AccountType !== undefined ? data.AccountType : 0]}</span>
      </div>

      <div class="sales-cell mdl-cell mdl-cell--6-col">
        <span>${data.SalesRepId}</span>
      </div>
    </div>
  `;
    return this._sanitizer.bypassSecurityTrustHtml(html);
  };


  private classNameReplace(oldElementClass: string, newElementClass: string): void {
    if(document.getElementsByClassName(oldElementClass).length > 0) {
      let element = document.getElementsByClassName(oldElementClass)[0];
      element.className = element.className.replace(oldElementClass, newElementClass);
    }
  }

  get isUserValid(): boolean {
    return (this.sharedService &&
      this.sharedService.user &&
      this.sharedService.user.Id &&
      this.sharedService.user.Id.trim() !== "");

  }

  onVendorButtonClick() {
    this.onVendorButtonClicked.emit(this.mapNumber);
  }

  onTestCenterMapPointClick() {
    this.onTestCenterMapPointButtonClicked.emit(this.mapNumber);
  }
}



// WEBPACK FOOTER //
// ./src/app/bar.component.ts